// src/pages/Drive.js
import React, { useState } from 'react';

// Estructura de la Unidad Compartida ARCSEG
const DRIVE_ESTRUCTURA = [
  {
    id: '00',
    nombre: '00_DOCUMENTOS_CIA_ARCSEG',
    icono: '🏢',
    color: '#1A2E44',
    descripcion: 'Documentos corporativos de la empresa',
    link: 'https://drive.google.com/drive/folders/0AKoDW_0skryJUk9PVA',
    subcarpetas: [
      { nombre: 'Brochure y presentaciones', icono: '📊' },
      { nombre: 'Contratos marco', icono: '📝' },
      { nombre: 'Certificaciones', icono: '🏆' },
    ]
  },
  {
    id: '02',
    nombre: '02_RECURSOS_HUMANOS',
    icono: '👥',
    color: '#7C3AED',
    descripcion: 'Nómina, contratos y evaluaciones del equipo',
    link: 'https://drive.google.com/drive/folders/0AKoDW_0skryJUk9PVA',
    subcarpetas: [
      { nombre: 'Contratos', icono: '📋' },
      { nombre: 'Evaluaciones', icono: '⭐' },
      { nombre: 'Roles de pago', icono: '💰' },
    ]
  },
  {
    id: '03',
    nombre: '03_CONTABILIDAD',
    icono: '💼',
    color: '#059669',
    descripcion: 'Facturas, estados financieros y declaraciones SRI',
    link: 'https://drive.google.com/drive/folders/0AKoDW_0skryJUk9PVA',
    subcarpetas: [
      { nombre: '01_Facturas_Emitidas', icono: '📄' },
      { nombre: '02_Facturas_Recibidas', icono: '📥' },
      { nombre: '03_Planillas_Costos', icono: '📊' },
      { nombre: '04_Flujo_Caja', icono: '💵' },
      { nombre: '05_Roles_Pago', icono: '👷' },
      { nombre: '06_Reportes_Contadora', icono: '📈' },
      { nombre: '07_SRI_Obligaciones', icono: '🏛️' },
    ]
  },
  {
    id: '04',
    nombre: '04_VENTAS_COMERCIAL_CRM',
    icono: '🎯',
    color: '#D97706',
    descripcion: 'Pipeline comercial, propuestas y contratos',
    link: 'https://drive.google.com/drive/folders/0AKoDW_0skryJUk9PVA',
    subcarpetas: [
      { nombre: 'Propuestas enviadas', icono: '📤' },
      { nombre: 'Contratos firmados', icono: '✍️' },
      { nombre: 'Brochures técnicos', icono: '📑' },
    ]
  },
  {
    id: '05',
    nombre: '05_MARKETING_REDES_SOCIALES',
    icono: '📣',
    color: '#DB2777',
    descripcion: 'Contenido para redes sociales y marketing',
    link: 'https://drive.google.com/drive/folders/0AKoDW_0skryJUk9PVA',
    subcarpetas: [
      { nombre: 'Imágenes y videos', icono: '🖼️' },
      { nombre: 'Posts programados', icono: '📅' },
      { nombre: 'Identidad corporativa', icono: '🎨' },
    ]
  },
  {
    id: '06',
    nombre: '06_SIG_REGISTRO_PROYECTOS',
    icono: '📁',
    color: '#2563EB',
    descripcion: 'Carpetas de proyectos activos, en revisión e históricos',
    link: 'https://drive.google.com/drive/folders/0AKoDW_0skryJUk9PVA',
    subcarpetas: [
      { nombre: '01_PROYECTOS_ACTIVOS', icono: '🟢' },
      { nombre: '02_PROYECTOS_EN_REVISION', icono: '🟡' },
      { nombre: '03_PROYECTOS_ENTREGADOS', icono: '🔵' },
      { nombre: '04_PROYECTOS_HISTORICOS', icono: '⚪' },
      { nombre: '05_PLANTILLAS', icono: '📋' },
    ]
  },
  {
    id: '07',
    nombre: '07_LEGAL',
    icono: '⚖️',
    color: '#64748B',
    descripcion: 'Documentos legales, permisos y registros',
    link: 'https://drive.google.com/drive/folders/0AKoDW_0skryJUk9PVA',
    subcarpetas: [
      { nombre: 'Constitución empresa', icono: '📜' },
      { nombre: 'Permisos y licencias', icono: '🔖' },
      { nombre: 'Seguros', icono: '🛡️' },
    ]
  },
];

// Links rápidos a herramientas
const LINKS_RAPIDOS = [
  { nombre: 'BD Maestra SIG', icono: '📊', color: '#0F9D58', link: 'https://docs.google.com/spreadsheets/d/1GAClyW9MuYq2zSriHasLaA6xbEo2WpsiYwQapvDGI4E/edit', desc: 'Google Sheets' },
  { nombre: 'HubSpot CRM', icono: '🎯', color: '#FF7A59', link: 'https://app.hubspot.com/contacts/51177381/deals', desc: 'Pipeline comercial' },
  { nombre: 'AppSheet Campo', icono: '📱', color: '#4285F4', link: 'https://www.appsheet.com', desc: 'App de campo' },
  { nombre: 'Portal Cliente', icono: '🌐', color: '#1A2E44', link: 'https://script.google.com/macros/s/AKfycbypsIeXv89P3x9P3faxpSYrZnpP5RTzy0j0TG1OjvhG1MbSHRj1CcN66gmfG658OOKS/exec', desc: 'Google Sites' },
  { nombre: 'Apps Script', icono: '⚙️', color: '#F4B400', link: 'https://script.google.com/home/projects/17TE0fgyg1kW0tVRniwWFh7WELmSzN-TU2IHU4IXX9xTw661ADE7BNEky/edit', desc: 'ARCSEG_SIG_v2.1' },
  { nombre: 'Firebase Console', icono: '🔥', color: '#FF6D00', link: 'https://console.firebase.google.com/project/arcseg-portal/overview', desc: 'Portal hosting' },
];

export default function Drive() {
  const [expandida, setExpandida] = useState('06');

  return (
    <div>
      {/* Header */}
      <div className="page-header">
        <div>
          <h1 className="page-title">📂 Drive ARCSEG</h1>
          <p className="page-subtitle">Unidad Compartida · esegovia@arcseg-ec.com · Acceso directo a carpetas</p>
        </div>
        <a
          href="https://drive.google.com/drive/u/0/shared-drives"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Abrir Drive →
        </a>
      </div>

      {/* Links rápidos */}
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 13, fontWeight: 600, color: '#6B7A89', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 1 }}>
          Herramientas rápidas
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 10 }}>
          {LINKS_RAPIDOS.map((link, i) => (
            <a
              key={i}
              href={link.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 14px', background: '#fff',
                border: '1px solid #E8ECF0', borderRadius: 10,
                textDecoration: 'none', transition: 'all 0.15s',
                cursor: 'pointer'
              }}
              onMouseEnter={e => e.currentTarget.style.borderColor = link.color}
              onMouseLeave={e => e.currentTarget.style.borderColor = '#E8ECF0'}
            >
              <div style={{
                width: 32, height: 32, borderRadius: 8,
                background: link.color + '20', display: 'flex',
                alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0
              }}>
                {link.icono}
              </div>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#1A2E44' }}>{link.nombre}</div>
                <div style={{ fontSize: 11, color: '#94A3B8' }}>{link.desc}</div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Estructura de carpetas */}
      <h2 style={{ fontSize: 13, fontWeight: 600, color: '#6B7A89', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 1 }}>
        Unidad compartida — estructura
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {DRIVE_ESTRUCTURA.map((carpeta) => (
          <div
            key={carpeta.id}
            className="card"
            style={{ padding: 0, overflow: 'hidden', cursor: 'pointer' }}
          >
            {/* Cabecera de carpeta */}
            <div
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '14px 16px',
                borderLeft: `4px solid ${carpeta.color}`,
              }}
              onClick={() => setExpandida(expandida === carpeta.id ? null : carpeta.id)}
            >
              <div style={{
                width: 36, height: 36, borderRadius: 8,
                background: carpeta.color + '15',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0
              }}>
                {carpeta.icono}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#1A2E44' }}>{carpeta.nombre}</div>
                <div style={{ fontSize: 12, color: '#6B7A89' }}>{carpeta.descripcion}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <a
                  href={carpeta.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={e => e.stopPropagation()}
                  style={{
                    fontSize: 12, color: carpeta.color, fontWeight: 600,
                    textDecoration: 'none', padding: '4px 12px',
                    border: `1px solid ${carpeta.color}40`,
                    borderRadius: 6, background: carpeta.color + '10'
                  }}
                >
                  Abrir →
                </a>
                <span style={{ color: '#94A3B8', fontSize: 14 }}>
                  {expandida === carpeta.id ? '▲' : '▼'}
                </span>
              </div>
            </div>

            {/* Subcarpetas expandidas */}
            {expandida === carpeta.id && (
              <div style={{
                padding: '8px 16px 14px 68px',
                borderTop: '1px solid #F0F4F8',
                background: '#FAFBFC'
              }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {carpeta.subcarpetas.map((sub, i) => (
                    <div
                      key={i}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 6,
                        padding: '5px 12px', background: '#fff',
                        border: '1px solid #E8ECF0', borderRadius: 20,
                        fontSize: 12, color: '#1A2E44'
                      }}
                    >
                      <span>{sub.icono}</span>
                      <span>{sub.nombre}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Nota informativa */}
      <div style={{
        marginTop: 20, padding: '12px 16px',
        background: '#F0F4F8', borderRadius: 10,
        fontSize: 12, color: '#6B7A89', display: 'flex', gap: 8
      }}>
        <span>💡</span>
        <span>Cada carpeta abre directamente en Google Drive. Para acceder necesitas estar autenticado con <strong>esegovia@arcseg-ec.com</strong></span>
      </div>
    </div>
  );
}